module.exports = __webpack_public_path__ + "5bae4feb1054ab64b970f1351b0b6724.png";